import { Component, OnInit, Renderer, ViewChild } from '@angular/core';
import { AppService } from './modules/shared/services/geral/app.service';
import { FilterUtils } from "primeng/utils";
import { TranslateService } from '@ngx-translate/core';
import { PlatformLocation } from '@angular/common';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})

export class AppComponent implements OnInit {

  constructor(
    public svc: AppService, 
    private tl: TranslateService, 
    private platformLocation: PlatformLocation
  ) { }

  public addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  public loadCSS() {
    var cssLink = $("<link id='tema'>");
    $("head #tema").remove();
    $("head").append(cssLink);

    cssLink.attr({
        rel: "stylesheet",
        type: "text/css",
        href: this.platformLocation.pathname + "assets/css/theme-black.css"
    });
  };

  ngOnInit() {
    try {
      this.loadCSS();

      FilterUtils['dataRange'] = (value, filter): boolean => {
        //converter value para data
        var dv = value.split(" ")[0].split("/");
        dv = new Date(dv[1] + "/" + dv[0] + "/" + dv[2]).getTime();

        //converter primeira Data do range
        var d1 = filter[0].split("/");
        d1 = new Date(d1[1] + "/" + d1[0] + "/" + d1[2]).getTime();

        if (filter[1] == null) {
          return dv == d1;
        } else {
          //converter segunda Data do range
          var d2 = filter[1].split("/");
          d2 = new Date(d2[1] + "/" + d2[0] + "/" + d2[2]).getTime();

          return dv >= d1 && dv <= d2;
        }
      }

      FilterUtils['dataCount'] = (value, filter): boolean => {
        var operador = filter[0];
        var dias = filter[1];
        var retorno = false;

        //Data do Processo
        var dv = value.split(" ")[0].split("/");
        dv = new Date(dv[1] + "/" + dv[0] + "/" + dv[2]);

        //Data Atual
        var dAtual = new Date();

        if (operador == "igual"){
          retorno = (dAtual == dv);
        }

        if (operador == "menor"){
          var dDiff = this.addDays(dAtual, dias);
          retorno = (dv.getTime() <= dDiff.getTime());
        }

        if (operador == "maior"){
          var dDiff = this.addDays(dAtual, dias);
          retorno = (dv.getTime() > dDiff.getTime());
        }

        return retorno;
      }

      this.svc.sbSelecionarIdioma("pt");
    } catch (e) {
      this.svc.sbExibirAlerta("error", this.tl.instant("geral.mensagens.ops"), this.tl.instant("geral.mensagens.suporte"));
    }
  }
}
